export const routes = (prefix = `finance-dashboard`) => [
    {
        path: `/${prefix}/coas/transactions/print`,
        name: `${prefix}.coas.transactions.print`,
        component: () => import('./tabs/transactions/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.index`,
                PageDescription: "Finance: COAS",
            },
        },
    },
    {
        path: `/${prefix}/coas/general-ledger/print`,
        name: `${prefix}.coas.general-ledger.print`,
        component: () => import('./tabs/general-ledger/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.index`,
                PageDescription: "Finance: COAS",
            },
        },
    },
    {
        path: `/${prefix}/coas/profit-loss/print`,
        name: `${prefix}.coas.profit-loss.print`,
        component: () => import('./tabs/profit-loss/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.index`,
                PageDescription: "Finance: COAS",
            },
        },
    },
    {
        path: `/${prefix}/coas/balance-sheet/print`,
        name: `${prefix}.coas.balance-sheet.print`,
        component: () => import('./tabs/balance-sheet/Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.index`,
                PageDescription: "Finance: COAS",
            },
        },
    },
    {
        path: `/${prefix}/coas`,
        name: `${prefix}.coas.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.index`,
                PageDescription: "Finance: COAS",
            },
        },
    }, {
        path: `/${prefix}/coas/journalentries`,
        name: `${prefix}.coas.journalentries`,
        component: () => import('./JournalEntries.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.coas.journalentries`,
                PageDescription: "Finance: Journal Entries",
            },
        },
    },
];